import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FormCloudEnvironmentResponse } from '~/models/Commons ';
import { RootState } from '~/store/index';

interface State {
    cloudEnvironment: FormCloudEnvironmentResponse[];
     authenticated: boolean;
}

const initialState: State = {
    cloudEnvironment: [],
    authenticated:false
};

const CloudEnvironmentSlice = createSlice({
    name: 'cloudEnvironment',
    initialState,
    reducers: {
        SET_CLOUDENVIRONMENT(state, { payload }: PayloadAction<FormCloudEnvironmentResponse[]>) {
            state.cloudEnvironment = payload;
        },
            DELETE_CLOUDENVIRONMENT_BYID(state, { payload }: PayloadAction<number>) {
            if (!Array.isArray(state.cloudEnvironment)) {
                state.cloudEnvironment = [];
            }

            state.cloudEnvironment = state.cloudEnvironment.map(item =>
                item.id !== payload ? item : { ...item, active: false }
            );
        },

        ADD_CLOUDENVIRONMENT(state, { payload }: PayloadAction<FormCloudEnvironmentResponse>) {
            const newScripts = [...state.cloudEnvironment, payload];
            state.cloudEnvironment = newScripts;
        },
        PATCH_CLOUDENVIRONMENT(state, { payload }: PayloadAction<FormCloudEnvironmentResponse>) {
            const newCloudEnvironment = [...state.cloudEnvironment];
            const findInd = newCloudEnvironment.findIndex(({ id }) => id === payload.id);
            if (findInd < 0) return;

            newCloudEnvironment[findInd] = { ...payload };
            state.cloudEnvironment = newCloudEnvironment;
        },
         SET_AUTHENTICATED(state, { payload }: PayloadAction<boolean>) {
            state.authenticated = payload;
        },
    },
});

export const selectCLoudEnvironment = (state: RootState) => state.script;

export const { SET_CLOUDENVIRONMENT, DELETE_CLOUDENVIRONMENT_BYID, ADD_CLOUDENVIRONMENT, PATCH_CLOUDENVIRONMENT,SET_AUTHENTICATED } =
    CloudEnvironmentSlice.actions;

export default CloudEnvironmentSlice.reducer;
